import { useParams } from "react-router-dom";
import CustomerAuditComponent from "../components/customeraudit";

export default function CustomerAduit() {
  const { customerId } = useParams();

  return <CustomerAuditComponent customerId={customerId} />;
}
